import { html } from 'lit-element';
import 'Components/Global/SifiveInput';
import 'Components/Global/SifiveButton';
import 'Components/Global/SifiveTextarea';
import 'Components/Global/SVGIcon';

export const editOrganization = function(orgData = {}, { endEditMode, saveChanges, discardChanges, saveStatus = 'Changes saved...' }) {

    const { name, location, website, email, description,
        facebookUrl, instagramUrl, twitterUrl, youtubeUrl } = orgData

    return html`
        <div class="wrapper">
            <section class="org-top-section-edit-container">
                <div class="flex-display mb-2">
                    <div class="back-link" @click="${endEditMode}">
                        <svg-icon src="assets/images/icons/arrow_left.svg"></svg-icon> Profile Overview
                    </div>
                    <div>${saveStatus}</div>
                </div>
                <div class="org-top-section">
                    <div>
                        <img src="assets/images/berkeley_sample.png" alt=""/>
                        <div><a href="">Upload Image</a></div>
                    </div>
                    <div class="middle">
                        <div class="field-label">Organization name</div>
                        <div>
                            <sifive-input name="name" .value=${name} @blur=${saveChanges}></sifive-input>
                        </div>
                        <div class="field-label">Location</div>
                        <div>
                            <sifive-input name="location" .value=${location} @blur=${saveChanges}></sifive-input>
                        </div>
                    </div>
                </div>
                <div class="grid-2 mb-2">
                    <div>
                        <div class="field-label">Website</div>
                        <sifive-input name="website" .value=${website} @blur=${saveChanges}></sifive-input>
                    </div>
                    <div>
                        <div class="field-label">Contact E-mail</div>
                        <div>
                            <sifive-input name="email" .value=${email} @blur=${saveChanges} placeholder="Email"></sifive-input>
                        </div>
                    </div>
                </div>
                <div class="mb-2">
                    <div class="field-label">Introduction</div>
                    <sifive-textarea
                        name="description"
                        .value=${description}
                        @blur=${saveChanges}
                     ></sifive-textarea>
                </div>
                <div class="field-label">Socials</div>
                <div class="grid-2 mb-2">
                    <div><sifive-input name="facebookUrl" .value=${facebookUrl} placeholder="Facebook" @blur=${saveChanges}></sifive-input></div>
                    <div><sifive-input name="instagramUrl" .value=${instagramUrl} placeholder="Instagram" @blur=${saveChanges}></sifive-input></div>
                    <div><sifive-input name="twitterUrl" .value=${twitterUrl} placeholder="Twitter" @blur=${saveChanges}></sifive-input></div>
                    <div><sifive-input name="youtubeUrl" .value=${youtubeUrl} placeholder="Youtube" @blur=${saveChanges}></sifive-input></div>
                </div>
                <sifive-button label="Discard Changes" @click=${discardChanges} /></sifive-button>
            </section>
        </div>
    `
}